import client from "@/utils/api/client";
import { DefaultApiProjectsIdDeleteRequest } from "@/web-client";
import { AxiosResponse } from "axios";

export const deleteProject = (
  request: DefaultApiProjectsIdDeleteRequest,
): Promise<AxiosResponse<void>> => client.projectsIdDelete(request);
